// extracted by mini-css-extract-plugin
module.exports = {"drawerIcon":"Icons_drawerIcon__1UhVy","open":"Icons_open__1oOAP"};